import ReactDOM from "react-dom";
import {useSelector} from "react-redux";
import {useModalDisable} from "../../../hooks/useModalDisable";
import {memo, useCallback, useMemo} from "react";
import {SVG_ICON} from "../../common/svg/svg-icon";
import {LoaderContent} from "../../common/loaders/LoaderContent/LoaderContent";
import {ModalOptionsMobile} from "./ModalOptionsMobile/ModalOptionsMobile";
import {ModalOptionsDesktop} from "./ModalOptionsDesktop/ModalOptionsDesktop";
import s from "./ModalOptions.module.css";

export const ModalOptions = memo(({
  id,
  isOpen,
  title,
  children,
  isLoading = false,
  handleClose,
  style,
  isFullHeightMobile,
}) => {

  const portal = document.getElementById('portal');

  const isMobile = useSelector(state => state.layout.isMobile);
  useModalDisable(id, isOpen);

  const getModalContent = useCallback(({handleCloseModal}) => (
    <>
      {title && (
        <div className={s.header}>
          <p className={s.title}>{title}</p>
          <button
            className={s.cross}
            onClick={handleCloseModal}
          >
            <span>{SVG_ICON?.CROSS('black', 2)}</span>
          </button>
        </div>
      )}
      <div className={s.content}>
        {isLoading && <LoaderContent width={30}/>}
        {!isLoading && children}
      </div>
    </>
  ), [title, children, isLoading]);

  const modalComponentProps = useMemo(() => ({
    ...(isMobile ? {isFullHeightMobile} : {}),
    getModalContent,
    isOpen,
    handleClose,
    style,
  }), [isOpen, handleClose, style, getModalContent, isFullHeightMobile, isMobile]);

  const ModalComponent = isMobile ? ModalOptionsMobile : ModalOptionsDesktop;

  if (!portal || !isOpen) return null;
  return ReactDOM.createPortal(<ModalComponent {...modalComponentProps}/>, portal);
});

